<template>
  <div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12">
          <h3 class="text-center">
            <slot />
          </h3>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div
        class="row text-center justify-content-between align-items-center mt-3 border border-dark p-1 py-md-1 px-md-5"
      >
        <div class="col-12">
          <carousel
            :scrollPerPage="true"
            :navigationEnabled="false"
            :perPage="5"
            :perPageCustom="[
              [320, 2],
              [768, 3],
              [1024, 5]
            ]"
            :autoplay="true"
            :loop="true"
            easing="linear"
            :speed="300"
          >
            <slide class="m-auto">
              <img
                src="/assets/images/partners/1.jpg"
                style="width: 171px; height: 131px; object-fill: cover"
              />
            </slide>
            <slide class="m-auto">
              <img
                src="/assets/images/partners/2_2.jpg"
                style="width: 140px; height: 122px; object-fill: cover"
              />
            </slide>
            <slide class="m-auto">
              <img
                src="/assets/images/partners/3.jpg"
                style="width: 139px; height: 120px; object-fill: cover"
              />
            </slide>
            <slide class="m-auto">
              <img
                src="/assets/images/partners/4.jpg"
                style="width: 146px; height: 134px; object-fill: cover"
              />
            </slide>
            <slide class="m-auto">
              <img
                src="/assets/images/partners/5.jpg"
                style="width: 123px; height: 114px; object-fill: cover"
              />
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide
  }
};
</script>
